import { TextField } from "@mui/material";

const DataFilter = ({
  filterKey,
  label,
  allowGlobal = false,
  disabled = false,
  onFilterChange,
  currentFilter,
  ...props
}) => {
  const handleValeChange = (e) => {
    const newValue = e.target.value;
    onFilterChange({
      key: filterKey,
      value: newValue || undefined,
      label: newValue || undefined,
      global: allowGlobal,
    });
  };

  return (
    <div className="inline-block m-2">
      <TextField
        label={label}
        type="date"
        size="small"
        value={currentFilter?.value || ""}
        onChange={handleValeChange}
        InputLabelProps={{ shrink: true }}
        fullWidth
        {...props}
      />
    </div>
  );
};

export default DataFilter;
